<template>
  <XTable
    :model="model_history"
    ref="history"
    :options="{ placeholder:'Search transaction',noContent: 'No transactions',is_row_selection: false,is_load_req: false,temp_row: null }"
  >
        <span slot="date" slot-scope="text,record">
          {{ text.record.created_at.split('T')[0] }}
        </span>
        <span slot="transaction" slot-scope="text,record">
          <template v-if="text.record.from_bank_account">
            {{ getAccountDestination(text.record) }}
          </template>
          <template v-else-if="text.record.to_bank_account">
            {{getAccountSource(text.record)}}
          </template>
        </span>
        <span slot="fund_out" slot-scope="text,record">
          <template v-if="text.record.from_bank_account">
            {{ text.record.amount }}
          </template>
        </span>
        <span slot="fund_in" slot-scope="text,record">
          <template v-if="text.record.to_bank_account">
            {{ text.record.amount }}
          </template>
        </span>
  </XTable>
</template>

<script>

import XTable from '../../components/x-table/XTable'
import * as TableCol from '../account/historyTbl'


export default {
  name: "ListHistoryContact",
  components:{
    XTable
  },
  data(){
    return{
      model_history: null
    }
  },
  methods:{

    getAccountDestination(record){
      if(record.to_bank_account)
        return 'Transferred to :' + record.to_bank_account.account_name + '(Bank account)'
      else if(record.to_matter)
        return 'Transferred to :' + record.to_matter.title + '(Matter)'
      else if(record.to_contact){
        if(record.to_contact.person)
          return `Transferred to : ${record.to_contact.person.first_name} ${record.to_contact.person.last_name} (Person)`
        else
          return `Transferred to : ${record.to_contact.company.name} (Company)`
      }
    },
    getAccountSource(record){
      if(record.from_bank_account)
        return 'Transferred from:' + record.from_bank_account.account_name + '(Bank account)'
      else if(record.from_matter)
        return 'Transferred from:' + record.from_matter.title + '(Matter)'
      else if(record.from_contact){
        if(record.from_contact.person)
          return `Transferred from: ${record.from_contact.person.first_name} ${record.from_contact.person.last_name} (Person)`
        else
          return `Transferred from: ${record.from_contact.company.name} (Company)`
      }else
        return `${record.to_bank_account.account_name}`
    },

  },
  mounted() {
    // this.$refs.history.fetch()
  },
  created() {
    this.model_history = TableCol.default
  }
}
</script>

<style scoped>

</style>
